import React, { useCallback, useState } from 'react';
import Tooltip from '@mui/material/Tooltip';
import { useTranslation } from 'react-i18next';

import CommonButton from '../common-button/CommonButton';
import Icon from '../../icons/Icon';
import { ICONS } from '../../icons';

import './CopyButton.scss';

const CopyButton = ({ onClick, disabled, buttonStyle = 'secondary', disableTooltip, disableInteractive = true }) => {
  const { t } = useTranslation();
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = useCallback(() => {
    if (isCopied) {
      return;
    }

    onClick();
    setIsCopied(true);

    setTimeout(() => {
      setIsCopied(false);
    }, 1000);
  }, [onClick, isCopied]);

  return (
    <Tooltip
      title={isCopied ? t('copied') : t('copy')}
      disableHoverListener={disableTooltip || disabled}
      disableInteractive={disableInteractive}>
      <div>
        <CommonButton
          styleColor={buttonStyle}
          className='common_copy-button'
          onClick={handleCopy}
          isStrokeIcon
          disabled={disabled}>
          {isCopied ? (
            <Icon icon={ICONS.Tick} currentColor disableCommonColors />
          ) : (
            <Icon icon={ICONS.Copy} currentColor disableCommonColors />
          )}
        </CommonButton>
      </div>
    </Tooltip>
  );
};

export default CopyButton;
